var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 45,
    viewBox: "0 0 18 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2875 4.59373H14.9937V1.59374C14.9937 0.706242 14.25 0 13.4 0H4.48135C3.59385 0 2.88757 0.706242 2.88757 1.59374V4.59373H1.59378C0.706281 4.59373 0 5.33748 0 6.18748V43.4063C0 44.2938 0.700031 45 1.59378 45H16.2875C17.175 45 17.8813 44.2938 17.8813 43.4063V6.18748C17.8751 5.33123 17.175 4.59373 16.2875 4.59373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62421 7.21877C1.62421 7.02502 1.78049 6.86877 1.97424 6.86877H15.8991C16.0929 6.86877 16.2491 7.02502 16.2491 7.21877V15.1188H1.62421V7.21877Z",
    fill: "#80ACD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62421 15.1188H16.2491V42.7875C16.2491 42.9688 16.0991 43.1188 15.9179 43.1188H1.96173C1.78048 43.1188 1.63046 42.9688 1.63046 42.7875V15.1188H1.62421Z",
    fill: "#BFD6EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3321 36.0813L7.97575 30.125C8.00075 30.075 7.97585 30.0187 7.9196 30.0187H4.46333C4.22583 30.0187 4.13202 29.8563 4.25077 29.6625L8.73823 22.3813C8.83198 22.225 9.00071 22.1188 9.18821 22.1188H12.6507C12.8882 22.1188 12.957 22.2875 12.832 22.475L9.37574 27.275C9.33824 27.325 9.37579 27.3813 9.42579 27.3813H13.3758C13.6383 27.3813 13.757 27.7125 13.5632 27.8875L4.45082 36.175C4.37582 36.2438 4.2821 36.1625 4.3321 36.0813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeIcon);
export default __webpack_public_path__ + "static/media/ChargeIcon.7035c044d15e179c507776703dcf3842.svg";
export { ForwardRef as ReactComponent };